// extracted by mini-css-extract-plugin
export default {"box":"orderPage_box__dFq8B"};